if (!customElements.get("blog-view-all")) {
  customElements.define(
    "blog-view-all",
    class BlogViewAll extends HTMLElement {
      constructor() {
        super();

        this.viewAllBtn = this.querySelector(".blog__view-all .blog__button");

        this.sliderComponent = this.previousElementSibling;
        this.sliderComponentList = this.sliderComponent.querySelector("ul.blog__posts");
        this.loadIcon = this.sliderComponent.querySelector(".action-loading");
        this.viewAllBtnMobile =
          this.sliderComponent.previousElementSibling.querySelector(".view-all-btn-mobile");

        if (this.viewAllBtn) {
          this.viewAllBtn.addEventListener("click", this.loadAllBlogs.bind(this));
        }

        if (this.viewAllBtnMobile) {
          this.viewAllBtnMobile.addEventListener("click", this.loadAllBlogsMobile.bind(this));
        }
      }

      loaderInView(blogHandle, sliderComponentList, callBackSuccessful, callBack) {
        $(sliderComponentList).html("");

        var blogTemplateUrl = "/blogs/" + blogHandle + "?view=blog_by_type";

        var resultPromise = fetch(blogTemplateUrl).then(function (res) {
          return res.text();
        });

        resultPromise
          .then(function (response) {
            if (response && response.trim() != "") {
              let allArticles = new DOMParser()
                .parseFromString(response.trim(), "text/html")
                .querySelectorAll(".blog__post");

              // ADD RESULT TO WRAPPER (the same wrapper that was emptied earlier)
              $(sliderComponentList).append(allArticles);
              callBackSuccessful();
            }
          })
          .catch(function (error) {
            console.error(
              "Failed to perform search. Check your internet connection and try again.",
              error
            );
          })
          .finally(callBack);
      }

      loadAllBlogs(event) {
        event.preventDefault();

        const hideViewBtn = () => {
          this.viewAllBtn.style.display = "none";
          this.viewAllBtnMobile.style.display = "none";
          this.sliderComponent.reInit();
        };

        const hideLoadIcon = () => {
          this.loadIcon.style.display = "none";
        };

        this.loadIcon.style.display = "block";
        this.loaderInView(
          this.dataset.blog_handle,
          this.sliderComponentList,
          hideViewBtn,
          hideLoadIcon
        );
      }

      loadAllBlogsMobile(event) {
        event.preventDefault();
        this.viewAllBtn.click();
      }
    }
  );
}
